<template>
  <div
    class="tooltip"
    :class="item.css_class"
    @mousemove="setVisible"
    @mouseleave="setInvisible"
    @click="toggle"
  >
    <transition name="chat-fade">
      <div
        v-if="isHovering"
        class="tooltip-text"
        :style="{
          backgroundColor: fairConfig.FC_TOOLTIP_BACKGROUND,
          color: fairConfig.FC_TOOLTIP_COLOR,
        }"
      >
        {{ item.link }}
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      isHovering: false,
    };
  },
  computed: {
    ...mapState(["fairConfig"]),
  },
  methods: {
    cancelInvis() {
      if (this.visibleId) {
        clearTimeout(this.visibleId);
        this.visibleId = null;
      }
    },
    setVisible() {
      this.isHovering = true;
      this.cancelInvis();
    },
    setInvisible() {
      this.visibleId = setTimeout(() => {
        this.isHovering = false;
      }, 1000);
    },
    toggle() {
      if (this.isMobile) this.isHovering = !this.isHovering;
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  .tooltip-text {
    max-width: 30em;
    color: #fff;
    background-color: rgb(19, 19, 19);
    padding: 0.5em;
    border-radius: 0.6em;
  }
}
</style>